const baseConfig = {
  productRadius: '12px',
  purchaseRadius: '15px',
  borderWidth: '1px',
  selectedBorderWidth: '2px',
  spacing: '10px',
  productPadding: '15px',
  containerRadius: '25px',
  badgeRadius: '8px',
  headingFont: '',
  googleFonts: '',
  font: '',
  direction: 'vertical', // vertical, horizontal
  reverseDirection: 'false', // true, false
  productCount: 'auto', // auto, one, two, three
  hideProducts: 'auto', // true, false, auto
  fontSize: 'calc(min(4.5vw, 1rem))',
  productDescription: 'show', // show, hide
  primaryProductBadge: 'show', // show, hide
  secondaryProductBadge: 'hide', // show, hide
  tertiaryProductBadge: 'hide', // show, hide
  productDivider: 'hide', // show, hide
  footerDivider: 'show', // show, hide
  footer: 'normal', // show, hide, compact
  footerAlignment: 'spread', // spread, center
  footerPosition: 'fixed', // true, false
  backgroundColor: 'rgba(19, 20, 23, 0.7)',
  foregroundColor: '#FFFFFF',
  brandColor: '#4E71FF',
  brandTextColor: '#FFFFFF',
  borderColor: 'rgb(70,70,70)',
  productBackgroundColor: 'rgba(0,0,0,0.85)',
  buttonBackgroundColor: '',
  paywallBackgroundColor: '#292929',
  statusBarPadding: '34px',
  paywallMaxWidth: '480px',
  minNavbarHeight: '64px',
  logoHeight: '35px',
  navCenter: 'show', // hide, mixed, text, image
  navLeft: 'mixed', // hide, mixed, text, icon, doubleIcon, doubleText, all
  navRight: 'mixed', // hide, mixed, text, icon, doubleIcon, doubleText, all
  navButtonIconsSize: '42px',
  nav: 'show', // hide, show
  navPosition: 'fixed', // true, false
  navBackgroundColor: 'auto', // auto or a color
  contentAlignment: 'top', // top, bottom, center
  autoAdjustContentAlignment: 'true', // true, false
  navLeftIconURL: '../public/assets/nav-button.svg',
  navLeftInnerIconURL: '../public/assets/nav-button.svg',
  navRightIconURL: '../public/assets/nav-button.svg',
  navRightInnerIconURL: '../public/assets/nav-button.svg',
  logoURL: '../public/assets/logo.svg',
  contentPadding: 'calc(var(--sw-spacing) * 1.6)',
  insetsTopContent: 'true', // true, false (ADDED)
  cardPadding: 'calc(var(--sw-spacing) * 1.6)',
  navBackgroundBlur: 'true', // true, false
  cardBackgroundBlur: 'true', // true, false
  brandSecondaryColor: '',
  pjs: 'https://cdn.superwall.me/runtime/entrypoint.js',
  forceDarkMode: 'false',
  previewDarkMode: 'false',
};

export default baseConfig;
